import { useWindowSize } from 'react-use';

export const useIsMobile = (): boolean => {
  const { width } = useWindowSize();
  return width < 1024;
};
